module.exports = __webpack_public_path__ + "img/village.4ecea75a.png";